/** @jsxImportSource theme-ui @jsxRuntime classic */
import { useStaticQuery, graphql } from 'gatsby';
import invariant from 'invariant';

const MENU_LINKS_QUERY = graphql`
  query MenuLinks {
    dataJson(jsonId: { eq: "menu" }) {
      menuLinkGroups {
        heading
        label
        links {
          label
          url
        }
        url
      }
      # menuLinkGroupsFooter {
      #   label
      #   links {
      #     label
      #     url
      #   }
      #   url
      # }
      menuSecondaryLinks {
        label
        url
      }
    }
    sanityGiftGuidePage {
      slug {
        current
      }
    }
  }
`;

export interface MenuLink {
  label: string;
  url: string;
}

export interface MenuLinkGroup {
  heading: string;
  label: string;
  url: string;
  links: MenuLink[];
}

export interface MenuLinkGroupFooter {
  label: string;
  url: string;
  links: MenuLink[];
}

export const useMenuLinkGroups = (): {
  menuLinkGroups: MenuLinkGroup[][];
  menuSecondaryLinks: MenuLink[];
  // menuLinkGroupsFooter: MenuLinkGroupFooter[];
} => {
  const { dataJson } =
    useStaticQuery<Queries.MenuLinksQuery>(MENU_LINKS_QUERY);
  invariant(dataJson, 'menu JSON data is required!');

  return dataJson as {
    menuLinkGroups: MenuLinkGroup[][];
    menuSecondaryLinks: MenuLink[];
    // menuLinkGroupsFooter: MenuLinkGroupFooter[];
  };
};
